import { Box, Flex, Heading, Text } from "@highoutput/ui-components";
import type { PostCoreDataFragment, PostsQuery } from "~/__generated__/graphql";
import type Nullable from "~/types/nullable";
import Footer from "../landing/v2/footer";
import Navbar from "../navbar";
import Show from "../utilities/show";
import Highlight from "./highlight";
import PostList from "./post-list";

type PostProps = {
  posts: PostsQuery["posts"];
  highlight?: Nullable<PostCoreDataFragment>;
};

export default function Blog({ posts, highlight }: PostProps) {
  return (
    <Flex direction="column" minHeight="100vh" minWidth={"355px"}>
      <Navbar />
      <Box w="full" bgColor="rgba(240,237,236,0.2)">
        <Box
          as="main"
          flexGrow={1}
          paddingBottom={{
            base: "64px",
            lg: "100px",
          }}
          fontFamily="'Inter', sans-serif"
          mx="auto"
        >
          <Box>
            <Box
              paddingTop={{
                base: "52px",
                xl: "80px",
              }}
              paddingX={{
                base: "16px",
                lg: "24px",
              }}
              bgColor="white"
              w="full"
            >
              <Box
                marginX="auto"
                maxWidth={{
                  base: "full" /* cover md breakpoint 🚀. change to 375 when necessary 😏. */,
                  lg: "1024px",
                  xl: "960px",
                }}
              >
                <Heading
                  variant={{
                    base: "44/48",
                    lg: "56/64",
                  }}
                  letterSpacing="-0.02em"
                  textAlign="center"
                  fontWeight={400}
                  color="rgb(13,48,80)"
                  fontSize={{ base: "44px", lg: "56px" }}
                  lineHeight={{ base: "48px", lg: "64px" }}
                >
                  Learn more about&nbsp;coaching
                </Heading>

                <Text
                  maxWidth="720px"
                  marginX="auto"
                  marginTop={{
                    base: "16px",
                    lg: "24px",
                  }}
                  variant={{
                    base: "16/24",
                    lg: "20/32",
                  }}
                  letterSpacing={{
                    base: "0.02em",
                    lg: "unset",
                  }}
                  textAlign="center"
                  color="rgba(13,48,80,0.8)"
                  marginBottom={{ base: "-20px" }}
                >
                  For insights on coaching and leadership to better understand the role they play
                  and the impact they have on your teams&nbsp;success.
                </Text>

                <Show when={!!highlight}>
                  <Highlight
                    marginTop={{
                      base: "64px",
                      xl: "80px",
                    }}
                    data={highlight}
                  />
                </Show>
              </Box>
            </Box>

            <PostList
              data={posts}
              // We expect to add more whitelist in the future here
              // especially if they decide to highlight multiple posts
              whitelist={highlight?.id ? [highlight.id] : []}
            />
          </Box>
        </Box>
      </Box>
      <Footer cta />
    </Flex>
  );
}
